import { render, staticRenderFns } from "./MpConnectV2.vue?vue&type=template&id=6c7a0700&scoped=true&"
import script from "./MpConnectV2.vue?vue&type=script&lang=js&"
export * from "./MpConnectV2.vue?vue&type=script&lang=js&"
import style1 from "./MpConnectV2.vue?vue&type=style&index=1&id=6c7a0700&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7a0700",
  null
  
)

export default component.exports